<div class="title">Pipelines</div>
<form class="job-selection-dialog-content" (keyup.enter)="select()">
    <cds-form-group layout="vertical">
        <cds-radio-group *ngIf="userName$ | async as userName">
            <cds-radio>
                <label>Segmentation</label>
                <input
                    type="radio"
                    name="segmentation"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.Segmentation"
                />
            </cds-radio>
            <cds-radio>
                <label>Nucleus Expansion</label>
                <input
                    type="radio"
                    name="nucleusexpansion"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.NucleusExpansion"
                />
            </cds-radio>
            <cds-radio>
                <label>Registration</label>
                <input
                    type="radio"
                    name="registration"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.Registration"
                />
            </cds-radio>
            <cds-radio>
                <label>Intensity Map</label>
                <input
                    type="radio"
                    name="intensity"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.MapIntensity"
                />
            </cds-radio>
            <!--            TODO: Re-Enable Clustering when backend is ready-->
            <!--            <cds-radio>-->
            <!--                <label>Clustering</label>-->
            <!--                <input-->
            <!--                    type="radio"-->
            <!--                    name="clustering"-->
            <!--                    [(ngModel)]="selectedPipeline"-->
            <!--                    [value]="PipelineTypeEnum.Clustering"-->
            <!--                />-->
            <!--            </cds-radio>-->
            <cds-radio>
                <label>Recurrent neighborhoods</label>
                <input
                    type="radio"
                    name="recurrentNeighborhoods"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.RecurrentNeighborhoods"
                />
            </cds-radio>
            <cds-radio>
                <label>Neighborhood enrichment</label>
                <input
                    type="radio"
                    name="neighborhoodEnrichment"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.NeighborhoodEnrichment"
                />
            </cds-radio>
            <cds-radio *ngIf="userName?.includes('demo')">
                <label>Automatic cell type detection</label>
                <input
                    type="radio"
                    name="autoCellDetection"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.AutoCellDetection"
                />
            </cds-radio>
        </cds-radio-group>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="select()" [disabled]="selectedPipeline === null">
        Select
    </cds-button>
</div>
